import {
  richtext_default
} from "./chunk-KYXE3IBT.js";
import {
  sanity_image_default
} from "./chunk-S7ZUUURB.js";
import {
  title_default
} from "./chunk-GI6JXUKL.js";
import {
  icon_default
} from "./chunk-KWWZIFUJ.js";
import {
  link_default
} from "./chunk-6WQWOYMP.js";
import {
  label_default
} from "./chunk-AWEODRKT.js";

// src/cards/show/show.tsx
import { format, isPast } from "date-fns";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var CardShow = forwardRef(
  ({
    className = "",
    description,
    endDate,
    id,
    image,
    labels = {
      learnMore: "Learn More",
      noUpcomingPerformances: "No Upcoming Performances"
    },
    nextPerformance,
    startDate,
    targetPage,
    ticketsAvailable,
    title
  }, ref) => {
    if (!title) return null;
    const nextFilteredPerformance = nextPerformance?.filter((performance) => {
      return !isPast(new Date(performance?.startDate || ""));
    })[0];
    return /* @__PURE__ */ jsxs(
      "article",
      {
        className: `${className} group overflow-hidden relative auto-rows-min theme-light grid grid-cols-1`,
        id,
        ref,
        children: [
          title && /* @__PURE__ */ jsx(
            title_default,
            {
              className: "title-md order-3 pb-6 pl-1 text-heritage-red-full",
              level: "h3",
              text: title
            }
          ),
          /* @__PURE__ */ jsx(
            label_default,
            {
              text: nextFilteredPerformance?.startDate ? format(
                nextFilteredPerformance?.startDate,
                "MMM d \xB7 EEE \xB7 h:mm a"
              ) : labels.noUpcomingPerformances,
              className: "body-xs order-2 pb-1 pl-1 uppercase"
            }
          ),
          description && /* @__PURE__ */ jsx("div", { className: "body-md line-clamp-4 order-4 overflow-hidden mb-6 pl-1", children: /* @__PURE__ */ jsx(richtext_default, { text: description }) }),
          image && /* @__PURE__ */ jsx(
            sanity_image_default,
            {
              className: "order-1 mb-3 relative rounded-sm overflow-hidden",
              imageClassName: "object-cover w-full group-hover:scale-[105%] transition-card-image",
              sanityImageSourceData: image,
              height: 280,
              width: 420
            }
          ),
          targetPage && /* @__PURE__ */ jsx("div", { className: "card-wrapping-link order-5 pl-1", children: /* @__PURE__ */ jsxs(
            link_default,
            {
              className: "link w-fit",
              href: targetPage || "#",
              tracking: {
                component: "Card Show",
                label: labels?.learnMore
              },
              children: [
                labels.learnMore,
                /* @__PURE__ */ jsx(
                  icon_default,
                  {
                    name: "arrow-short-right",
                    className: "h-[0.7em] pt-[0.1em] group-hover:translate-x-1 transition-translate",
                    SVGClassName: "w-auto h-full"
                  }
                )
              ]
            }
          ) })
        ]
      }
    );
  }
);
var show_default = CardShow;

export {
  show_default
};
